import React from "react";
import classes from "./Card.module.css";
import {
  BsCodeSlash,
  BsFillDatabaseFill,
  BsFillLaptopFill,
} from "react-icons/bs";

const Card = (props) => {
  return (
    <div className={classes.card}>
      <div className={classes.iconWrapper}>
        {props.title === "Front-end" ? (
          <BsCodeSlash className={classes.icon} color="white" size={40} />
        ) : props.title === "Back-end" ? (
          <BsFillDatabaseFill
            className={classes.icon}
            color="white"
            size={40}
          />
        ) : (
          <BsFillLaptopFill className={classes.icon} color="white" size={40} />
        )}
      </div>
      <h2 className={classes.title}>{props.title}</h2>
      <p className={classes.p}>{props.content}</p>
    </div>
  );
};

export default Card;
